import { array, option } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { useRepositoryQuery } from '@mews-commander/data-access';
import { useCurrentEnterpriseId } from '@mews-commander/core';
import { createActorProfilesMapper } from '@mews-commander/utils';
import { createPaymentPolicyMapper } from './utils';

export const useRateGroupGet = (rateGroupId?: string) =>
    useRepositoryQuery(
        'rateGroups',
        'getAll',
        {
            rateGroupIds: [rateGroupId ?? ''],
            enterpriseIds: [useCurrentEnterpriseId()],
            extent: {
                paymentPolicies: true,
            },
        },
        {
            staleTime: 5000,
            enabled: !!rateGroupId,
            select: ({ rateGroups, settlementRules, cancellationPolicies, profiles }) =>
                pipe(
                    rateGroups,
                    array.findFirst(({ id }) => id === rateGroupId),
                    option.map(
                        createPaymentPolicyMapper({
                            cancellationPolicies: cancellationPolicies ?? [],
                            settlementRules: settlementRules ?? [],
                        })
                    ),
                    // omitting the `settlementRules` and `cancellationPolicies` from the result
                    option.map(({ settlementRules: srs, cancellationPolicies: cps, ...other }) => other),
                    option.map(createActorProfilesMapper(profiles)),
                    option.getOrElseW(() => undefined)
                ),
        }
    );
